import { render, staticRenderFns } from "./DataListCorporates.vue?vue&type=template&id=6dfc2670&scoped=true&"
import script from "./DataListCorporates.vue?vue&type=script&lang=js&"
export * from "./DataListCorporates.vue?vue&type=script&lang=js&"
import style0 from "./DataListCorporates.vue?vue&type=style&index=0&id=6dfc2670&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dfc2670",
  null
  
)

export default component.exports